import React from "react"
import { useStaticQuery, graphql } from "gatsby"

import Modal from "./modal"

export default (props) => {
  const data = useStaticQuery(graphql`
    query {
      translations: translationsJson {
        global {
          close
        }
      }
    }
  `)

  return <Modal {...props} translations={data.translations} />
}
